import { useFlags } from "flagsmith/react";
import { useEffect } from "react";
import { useAuthStore } from "store/auth.store";
import { bootCommandBar, shutdownCommandBar } from "utils/commandbar";

export function SupportWidgets() {
	const zendeskFlags = useFlags(["enable_zendesk"]);
	const chatbaseFlags = useFlags(["enable_chatbase"]);
	const commandbarFlags = useFlags(["enable_commandbar"]);

	const enableZendesk = zendeskFlags?.enable_zendesk?.enabled;
	const enableChatbase = chatbaseFlags?.enable_chatbase?.enabled;
	const enableCommandBar = commandbarFlags?.enable_commandbar?.enabled;

	const uid = useAuthStore((state) => state.uid);

	useEffect(() => {
		if (enableZendesk) {
			loadZendesk();
		}
	}, [enableZendesk]);

	useEffect(() => {
		if (enableChatbase) {
			loadChatbase();
		}
	}, [enableChatbase]);

	useEffect(() => {
		if (enableCommandBar && uid) {
			bootCommandBar();
		}
		return () => {
			if (enableCommandBar) {
				shutdownCommandBar();
			}
		};
	}, [enableCommandBar, uid]);

	return null;
}

function loadZendesk() {
	if (document.getElementById("ze-snippet")) return;

	console.log("Loading Zendesk widget");
	const script = document.createElement("script");
	script.id = "ze-snippet";
	script.src =
		"https://static.zdassets.com/ekr/snippet.js?key=1e8a08fb-6498-4531-a5c0-5c0d7a926d44";
	document.head.appendChild(script);
}

function loadChatbase() {
	// Check if script is already loaded
	if (document.getElementById("fHeh-rQ8QYK3fz9TY-Aaj")) {
		console.log("Chatbase widget already loaded");
		return;
	}

	console.log("Loading Chatbase widget");

	// Initialize chatbase queue if not exists
	if (!window.chatbase) {
		window.chatbase = (...params: any[]) => {
			if (!window.chatbase.q) {
				window.chatbase.q = [];
			}
			window.chatbase.q.push(params);
		};
		window.chatbase = new Proxy(window.chatbase, {
			get(target: any, prop: any) {
				if (prop === "q") {
					return target.q;
				}
				return (...args: any[]) => target(prop, ...args);
			},
		});
	}

	const onLoad = () => {
		// Double-check script isn't already added
		if (document.getElementById("fHeh-rQ8QYK3fz9TY-Aaj")) {
			return;
		}

		const script = document.createElement("script");
		script.src = "https://www.chatbase.co/embed.min.js";
		script.id = "fHeh-rQ8QYK3fz9TY-Aaj";
		(script as any).domain = "www.chatbase.co";
		document.body.appendChild(script);
	};

	if (document.readyState === "complete") {
		onLoad();
	} else {
		window.addEventListener("load", onLoad, { once: true });
	}
}
